import React, { Fragment, useState } from 'react'
import {
  Typography, Container, Card, CardContent, Button, Grid, LinearProgress, DialogContent, Dialog, IconButton
} from '@material-ui/core'
import { InfoOutlined } from '@material-ui/icons'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import moment from 'moment'
import { useFetch } from './context/useFetch'
import i18n from './i18n/i18n'
import ReactMarkdown from 'react-markdown'

const PackConsumption = ({ showChangePack = true }) => {
  const profileId = useSelector((state) => state.profile.user.profile_id)
  const profileType = useSelector((state) => state.profile.user.profile_type)

  if (profileType !== 'Company') return null

  return <LoadedPack profileId={profileId} showChangePack={showChangePack} />
}

const LoadedPack = ({ profileId, showChangePack }) => useFetch(
  ({ fetch }) => ({
    pack: fetch(`companies/${profileId}/packs`)
  }),
  () => (
    <Fragment>
      <Typography variant="h2" align="left" style={{ marginTop: '5%' }}>
        {i18n.t('profile.entreprise.pack.title')}
      </Typography>
      <PackCard showChangePack={showChangePack} />
    </Fragment>
  )
)

const PackCard = ({ showChangePack }) => {
  const packFinishDate = useSelector((state) => state.profile.pack_finishing_date)
  const pack = useSelector((state) => state.pack)
  const consumptionRate = useSelector((state) => state.profile.pack_consumption_rate)
  const router = useRouter()
  const [showDetails, setShowDetails] = useState(false)

  const handleChangePack = () => {
    router.push('/entreprise/profile/subscriptions')
  }

  return (
    <Card>
      <CardContent>
        {showDetails &&
          <Dialog open onClose={() => setShowDetails(false)}>
            <DialogContent>
              <Typography variant="body1" align="left" gutterBottom component="div" className="offer-corp">
                <ReactMarkdown skipHtml linkTarget="_blank">
                  {pack.description}
                </ReactMarkdown>
              </Typography>
            </DialogContent>
          </Dialog>
        }

        <Grid container spacing={1}>
          <Grid item xs={showChangePack ? 6 : 12} style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Typography variant="h3">{pack.label}</Typography>
            <IconButton onClick={() => setShowDetails(true)} color="primary" aria-label="info" size="small">
              <InfoOutlined />
            </IconButton>
          </Grid>
          {showChangePack && (
            <Grid item xs={6} style={{ marginBottom: '20px', textAlign: 'right' }}>
              <Button onClick={handleChangePack} variant="contained" color="primary">
                {i18n.t('profile.entreprise.pack.change_pack')}
              </Button>
            </Grid>
          )}

          <Grid item xs={12}>
            <Typography
              style={{
                '& span': {
                  fontWeight: 'bold'
                }
              }}
              dangerouslySetInnerHTML={{ __html: i18n.t('profile.entreprise.pack.consumption_rate', { rate: parseFloat(consumptionRate) }) }}
            />
          </Grid>
          <Grid item xs={12}>
            <LinearProgress variant="determinate" value={parseFloat(consumptionRate)} />
          </Grid>

          <Grid item xs={12}>
            <Typography color="textSecondary" style={{ fontSize: '12px', fontStyle: 'italic' }}>
              {packFinishDate &&
                <Fragment>{i18n.t('profile.entreprise.pack.available_until', { date: moment(packFinishDate).format('DD MMMM YYYY') })}</Fragment>
              }

              {!packFinishDate &&
                <Fragment>{i18n.t('profile.entreprise.pack.available_unlimited')}</Fragment>
              }
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default PackConsumption
